import React from 'react'
import { useTranslation } from 'react-i18next';
import customTheme from '../utils/ui';
import Portal from '@mui/material/Portal';
import { Typography, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
const ConfirmationDialog = ({ visible, hideDialog, title, body, confirmCb }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    return (
        <Portal>
            <Dialog open={visible} dismissable onClose={hideDialog} style={{ width: '100%', alignSelf: 'center', borderRadius: 10 }}>
                <DialogContent>
                    <div style={{ padding: 0, margin: 0 }}>
                        <Typography style={{ marginTop: 5,marginBottom: 5, textAlign: 'center' }}>{t(title)}</Typography>
                        <Typography style={{ marginTop: 10,marginBottom: 10,  textAlign: 'center' }}>
                            {t(body)}
                        </Typography>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ backgroundColor: 'green', color:"white"}} onClick={confirmCb}>{t('general.yes')}</Button>
                    <Button style={{ backgroundColor: 'red', color:"white"}} onClick={hideDialog}>{t('general.no')}</Button>
                </DialogActions>
            </Dialog>
        </Portal>
    )
}

export default ConfirmationDialog